<template>
  <input type="text" class="form-control input" :class="inputClass"
         :id="id" :name="name" :placeholder="placeholder" :required="required"
         :readonly="readOnly" :disabled="disabled">
</template>

<script>
import { markRaw } from 'vue'
import $ from 'jquery'
import moment from 'moment'
import 'eonasdan-bootstrap-datetimepicker'
import VueFormHelper from '../common/VueFormHelper'

export default {
  props: {
    modelValue: {
      default: null,
      validator: value => value === null || value instanceof Date || typeof value === 'string' || moment.isMoment(value)
    },
    config: { type: Object, default: () => ({}) },
    placeholder: { type: String, default: '' },
    inputClass: { type: [String, Object], default: '' },
    name: { type: String, default: 'datetime' },
    required: Boolean,
    readOnly: Boolean,
    disabled: Boolean,
    wrap: Boolean,
    id: String
  },
  emits: ['update:modelValue'],
  data () {
    return { dp: null }
  },
  mounted () {
    const element = $(this.wrap ? this.$el.parentNode : this.$el)
    element.datetimepicker(this.config)
    this.dp = markRaw(element.data('DateTimePicker'))
    this.dp.date(this.modelValue || null)
    element.on('dp.change.mdbDatePicker', this.onChange)
  },
  beforeUnmount () {
    $(this.wrap ? this.$el.parentNode : this.$el).off('.mdbDatePicker')
    this.dp.destroy()
    this.dp = null
  },
  watch: {
    modelValue (value) {
      this.dp.date(value || null)
    },
    config: {
      deep: true,
      handler (config) {
        this.dp.options({ ...config })
      }
    }
  },
  methods: {
    onChange (event) {
      const value = event.date ? VueFormHelper.convertDateToString(event.date) : null
      if (value !== this.modelValue) this.$emit('update:modelValue', value)
    }
  }
}
</script>
